import type { APITypes } from '../../../../primary-record-types';

/** Linked: the note tracks, or is tracked by, a counterpart note. Retained: it once was and now stands alone. */
export type NoteLinkState = 'linked' | 'retained';

/**
 * A note's link to a counterpart note, shown as a pill beside its title: a client-record copy is linked while it
 * tracks its profile note and retained once it stands alone; a profile note is linked while the reader's
 * organization holds a copy of it. Only professionals acting for an organization on the profile are told about
 * copies, so nobody else sees a pill on a profile note.
 */
export default function getNoteLinkState(
    note: APITypes.notesService.NoteDetails | APITypes.notesService.NoteListItem,
): NoteLinkState | null {
    if (note.mirror) return note.mirror.isLive ? 'linked' : 'retained';
    return note.mirroredTo?.length ? 'linked' : null;
}
